module.exports = ['$scope', '$http', function($scope, $http) {



}];